module.exports = __webpack_public_path__ + "./DennisPhoto_7cc946495eec56360c9f0aeffdc80965.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2021/DennisPhoto.png
// module id = 525
// module chunks = 0